import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import SystemUpdateIcon from '@mui/icons-material/SystemUpdate';
import useVersionCheck from '../../hooks/useVersionCheck';

const UpdateBanner: React.FC = function UpdateBanner() {
  const { handleDismiss, handleRefresh, updateAvailable } = useVersionCheck();

  if (!updateAvailable) return null;

  return (
    <Box
      sx={{
        alignItems: 'center',
        background: '#005DA2',
        color: '#fff',
        display: 'flex',
        gap: 1.5,
        justifyContent: 'center',
        left: 0,
        p: '8px 16px',
        position: 'fixed',
        right: 0,
        top: 0,
        zIndex: 9999
      }}
    >
      <SystemUpdateIcon sx={{ fontSize: 18 }} />
      <Typography sx={{ fontSize: '13px', fontWeight: 500 }}>
        A new version of Bluberry is available.
      </Typography>
      <Button
        onClick={handleRefresh}
        size="small"
        sx={{
          background: '#fff',
          borderRadius: '6px',
          color: '#005DA2',
          fontSize: '12px',
          fontWeight: 600,
          ml: 1,
          px: 2,
          textTransform: 'none',
          '&:hover': { background: '#E6F1FB' }
        }}
      >
        Refresh now
      </Button>
      <Typography
        onClick={handleDismiss}
        sx={{
          cursor: 'pointer',
          fontSize: '12px',
          ml: 1,
          opacity: 0.7,
          '&:hover': { opacity: 1 }
        }}
      >
        Dismiss
      </Typography>
    </Box>
  );
};

export default UpdateBanner;
